<template>
    <div>
        <Head title="Продукти"/>
        <h1 class="mb-8 text-3xl font-bold">Продукти</h1>

        <!-- Page description -->
        <div class="bg-white rounded-md shadow mb-6 p-6">
            <h2 class="text-lg font-semibold mb-3">Опис сторінки продуктів</h2>
            <ckeditor :editor="editor" v-model="description" :config="editorConfig" class="description-editor"/>
            <div class="mt-3 flex items-center gap-4">
                <button @click="saveDescription" :disabled="saving" class="btn-indigo">
                    {{ saving ? 'Зберігаємо...' : 'Зберегти опис' }}
                </button>
                <span v-if="saved" class="text-sm text-green-600">Збережено</span>
            </div>
        </div>

        <div class="flex items-center justify-between mb-6">
            <Link class="btn-indigo" :href="$route('products.create')">
                <span>Створити</span>
                <span class="hidden md:inline"> продукт</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                    <th class="pb-4 pt-6 px-6">Ціна (грн)</th>
                    <th class="pb-4 pt-6 px-6">Залишок</th>
                    <th class="pb-4 pt-6 px-6">Активний</th>
                </tr>
                <tr v-for="product in products.data" :key="product.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('products.edit', product.id)" tabindex="-1">
                            {{ product.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('products.edit', product.id)" tabindex="-1">
                            {{ product.price }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('products.edit', product.id)" tabindex="-1">
                            {{ product.quantity }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('products.edit', product.id)" tabindex="-1">
                            {{ product.is_active ? 'Так' : 'Ні' }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="$route('products.edit', product.id)" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="products.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="5">Немає жодного продукту</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="products.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import {Inertia} from '@inertiajs/inertia'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue'

export default {
    components: {Head, Icon, Link, Pagination, ckeditor: CKEditor.component},
    layout: Layout,
    props: {
        products:        {type: Object, required: true},
        listDescription: {type: String, default: ''},
    },
    data() {
        return {
            editor:       ClassicEditor,
            editorConfig: {},
            description:  this.listDescription,
            saving:       false,
            saved:        false,
        }
    },
    methods: {
        saveDescription() {
            this.saving = true
            this.saved  = false
            Inertia.post(
                this.$route('products.description.save'),
                {description: this.description},
                {
                    preserveScroll: true,
                    onSuccess: () => { this.saved = true },
                    onFinish:  () => { this.saving = false },
                }
            )
        },
    },
}
</script>

<style scoped>
:deep(.description-editor .ck.ck-editor__editable_inline) {
    min-height: 150px;
}
</style>
